import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User clicked "View key images"',
  name: 'clicked_view_key_images',
  params: [
    {
      description: 'The id of the person',
      name: 'person_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Location of event',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['named-people-page', 'unnamed-people-page', 'person-page-menu', 'people-settings'],
    },
  ],
};

export default META;
